import { useAuthStore } from "@/stores/auth";

export default defineNuxtRouteMiddleware(() => {
  const authStore: any = useAuthStore();
  const localePath = useLocalePath();

  if (!authStore.loggedIn || !authStore.user) {
    return;
  }

  if (authStore.user?.role !== "customer-admin") {
    return navigateTo(localePath("/dashboard"));
  }
});
